<div class="stats-wrapper">
  <!-- Top Bar -->
  <div class="stats-topbar">
    <div class="stats-title-block">
      <span class="stats-title">Estadísticas</span>
    </div>
    <div
      [ngClass]="{
        'calendar-selector': rangeDates && rangeDates.length > 0,
        'calendar-selector-empty': !rangeDates || rangeDates.length < 1
      }"
    >
      <p-calendar
        #calendar
        [touchUI]="isHandset"
        appendTo="body"
        [showIcon]="true"
        inputId="icon"
        [(ngModel)]="rangeDates"
        selectionMode="range"
        [readonlyInput]="true"
        placeholder="Selecciona un rango de fecha"
        data-testid="date-range-selector"
      >
        <ng-template pTemplate="footer">
          <div class="p-datepicker-buttonbar">
            <button
              type="button"
              pbutton=""
              pripple=""
              (click)="onClean()"
              class="p-element p-ripple p-button-text p-button p-component"
            >
              <span class="p-button-label">Cancelar</span>
            </button>
            <button
              type="button"
              pbutton=""
              pripple=""
              (click)="onDateSelect()"
              class="p-element p-ripple p-button-text p-button p-component"
            >
              <span class="p-button-label">Buscar</span>
            </button>
          </div>
        </ng-template>
      </p-calendar>
    </div>
  </div>

  <!-- KPI Row -->
  <div class="kpi-row">
    <div
      class="kpi-card"
      data-testid="metric-unique-interactions"
      data-metric="unique-interactions"
    >
      <div class="kpi-header">
        <div class="kpi-icon-wrap kpi-icon-wrap--purple"><i class="pi pi-users"></i></div>
        <span class="kpi-label">Interacciones únicas</span>
        <i
          class="pi pi-info-circle kpi-info"
          pTooltip="Número de personas que interactuaron con el chatbot"
          tooltipPosition="top"
          appendTo="body"
        ></i>
      </div>
      <div class="kpi-body">
        <span
          class="kpi-value"
          [ngClass]="{ 'kpi-value--empty': !data.conversation_count }"
          data-testid="metric-unique-interactions-value"
          >{{ data.conversation_count ?? 0 }}</span
        >
      </div>
    </div>

    <div class="kpi-card" data-testid="metric-messages-answered" data-metric="messages-answered">
      <div class="kpi-header">
        <div class="kpi-icon-wrap kpi-icon-wrap--indigo"><i class="pi pi-comments"></i></div>
        <span class="kpi-label">Mensajes atendidos</span>
        <i
          class="pi pi-info-circle kpi-info"
          pTooltip="Cantidad de mensajes respondidos por el chatbot"
          tooltipPosition="top"
          appendTo="body"
        ></i>
      </div>
      <div class="kpi-body">
        <span
          class="kpi-value"
          [ngClass]="{ 'kpi-value--empty': !data.messages_count }"
          data-testid="metric-messages-answered-value"
          >{{ data.messages_count ?? 0 }}</span
        >
      </div>
    </div>

    <div class="kpi-card" data-testid="metric-leads-count" data-metric="leads-count">
      <div class="kpi-header">
        <div class="kpi-icon-wrap kpi-icon-wrap--emerald"><i class="pi pi-star"></i></div>
        <span class="kpi-label">Clientes Potenciales</span>
        <i
          class="pi pi-info-circle kpi-info"
          pTooltip="Cantidad de leads (clientes potenciales) detectados en el período"
          tooltipPosition="top"
          appendTo="body"
        ></i>
      </div>
      <div class="kpi-body">
        <span
          class="kpi-value"
          [ngClass]="{ 'kpi-value--empty': !data.leads_count }"
          data-testid="metric-leads-count-value"
          >{{ data.leads_count ?? 0 }}</span
        >
      </div>
    </div>

    <div class="kpi-card" data-testid="metric-conversion-rate" data-metric="conversion-rate">
      <div class="kpi-header">
        <div class="kpi-icon-wrap kpi-icon-wrap--amber"><i class="pi pi-chart-bar"></i></div>
        <span class="kpi-label">Tasa de conversión</span>
        <i
          class="pi pi-info-circle kpi-info"
          pTooltip="Porcentaje de leads (clientes potenciales) convertidos sobre cerrados"
          tooltipPosition="left"
          appendTo="body"
        ></i>
      </div>
      <div class="kpi-body">
        <span
          class="kpi-value"
          [ngClass]="{ 'kpi-value--empty': !data.conversion_rate }"
          data-testid="metric-conversion-rate-value"
          >{{ (data.conversion_rate ?? 0) + '%' }}</span
        >
      </div>
    </div>
  </div>

  <!-- Charts Row: Activity + Keywords -->
  <div class="charts-row">
    <!-- Momentos de más actividad -->
    <div class="stat-card" data-testid="chart-hours-activity">
      <div class="card-header">
        <span class="card-title">Momentos de más actividad</span>
        <i
          class="pi pi-info-circle card-info"
          pTooltip="Distribución de mensajes por hora del día en el período seleccionado"
          tooltipPosition="top"
          appendTo="body"
        ></i>
      </div>

      <ng-container *ngIf="hasActivityData; else noDataTemplateActivity">
        <div class="activity-bar-container">
          <canvas
            baseChart
            type="bar"
            [data]="activityBarData"
            [options]="activityBarOptions"
            data-testid="chart-hours-canvas"
            data-chart-type="hours"
          ></canvas>
        </div>

        <div class="activity-peaks">
          <div
            class="peak-badge"
            *ngFor="let slot of activityTopSlots; trackBy: trackByPeakLabel"
            [style.--peak-color]="slot.color"
          >
            <span class="peak-dot"></span>
            <span class="peak-label">{{ slot.label }}</span>
            <span class="peak-pct">{{ slot.percent }}</span>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Keywords más repetidas -->
    <div class="stat-card" data-testid="chart-keywords">
      <div class="card-header">
        <span class="card-title">Keywords más repetidas</span>
        <i
          class="pi pi-info-circle card-info"
          pTooltip="Palabras clave más mencionadas por los usuarios en el período"
          tooltipPosition="top"
          appendTo="body"
        ></i>
      </div>

      <div class="keywords-ranked" *ngIf="keywords.length > 0; else noDataTemplateKeywords">
        <div
          class="keyword-row"
          *ngFor="let kw of keywords; trackBy: trackByKeyword; let i = index"
        >
          <span class="kw-rank">#{{ i + 1 }}</span>
          <span class="kw-text">{{ kw.keyword }}</span>
          <span class="kw-badge">{{ kw.count }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Bottom Row: Channels + Satisfaction -->
  <div class="charts-row">
    <!-- Conversaciones por canal -->
    <div class="stat-card" data-testid="chart-channels">
      <div class="card-header">
        <span class="card-title">Conversaciones por canal</span>
        <i
          class="pi pi-info-circle card-info"
          pTooltip="Distribución de conversaciones según el canal de origen (Web, WhatsApp, Messenger, etc.)"
          tooltipPosition="left"
          appendTo="body"
        ></i>
      </div>

      <ng-container *ngIf="hasPieChartData; else noDataTemplatePie">
        <div class="donut-wrapper">
          <div class="donut-chart-area">
            <canvas
              baseChart
              [type]="'doughnut'"
              [data]="channelDoughnutData"
              [options]="channelDoughnutOptions"
              data-testid="chart-channels-canvas"
              data-chart-type="channels"
            ></canvas>
            <div class="donut-center">
              <span class="donut-total">{{ channelTotal }}</span>
              <span class="donut-sublabel">conversaciones</span>
            </div>
          </div>
        </div>

        <div class="channel-legend">
          <div class="legend-item" *ngFor="let seg of channelSegments; trackBy: trackByChannelName">
            <div class="legend-dot" [style.background-color]="seg.color"></div>
            <span class="legend-name">{{ seg.name }}</span>
            <span class="legend-pct">{{ seg.percent | number : '1.0-0' }}%</span>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Nivel de satisfacción del usuario -->
    <div class="stat-card" data-testid="chart-feedback">
      <div class="card-header">
        <span class="card-title">Nivel de satisfacción del usuario</span>
        <i
          class="pi pi-info-circle card-info"
          pTooltip="Valoraciones que los usuarios han dado al chatbot en el período"
          tooltipPosition="left"
          appendTo="body"
        ></i>
      </div>

      <ng-container *ngIf="hasGaugeData; else noDataTemplateFeedback">
        <div class="gauge-wrapper">
          <div class="gauge-chart-area">
            <canvas
              baseChart
              [type]="'doughnut'"
              [data]="gaugeData"
              [options]="gaugeOptions"
              data-testid="chart-feedback-canvas"
              data-chart-type="feedback"
            ></canvas>
            <div class="gauge-center-label">
              <span class="gauge-pct-value" [style.color]="gaugeColor"
                >{{ satisfactionPositivePercent }}%</span
              >
              <span class="gauge-pct-sub">positivas</span>
            </div>
          </div>
          <div class="gauge-scale-row">
            <span class="gauge-scale-label">0%</span>
            <span class="gauge-scale-label">100%</span>
          </div>
          <div class="gauge-legend-row">
            <span class="gauge-legend-item">
              <span class="gauge-legend-dot" style="background: #7b5cf5"></span>Positivas
            </span>
            <span class="gauge-legend-item">
              <span class="gauge-legend-dot" style="background: #f87171"></span>Negativas
            </span>
            <span class="gauge-legend-item">
              <span class="gauge-legend-dot" style="background: #e5e7eb"></span>Sin valorar
            </span>
          </div>
        </div>

        <div class="sat-stats-row">
          <div class="sat-stat">
            <i class="pi pi-thumbs-up sat-icon"></i>
            <span class="sat-value">{{ satisfactionPositivePercent }}%</span>
            <span class="sat-label">Positivas</span>
          </div>
          <div class="sat-stat">
            <i class="pi pi-thumbs-down sat-icon sat-icon--neg"></i>
            <span class="sat-value">{{ satisfactionNegativePercent }}%</span>
            <span class="sat-label">Negativas</span>
          </div>
          <div class="sat-stat">
            <i class="pi pi-comments sat-icon"></i>
            <span class="sat-value">{{ satisfactionTotal }}</span>
            <span class="sat-label">Total</span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Monthly Conversations Bar Chart -->
  <div class="stat-card stat-card--full" data-testid="chart-monthly-conversations">
    <div class="card-header">
      <span class="card-title">Cantidad de conversaciones al mes</span>
      <div class="card-header-right">
        <div class="legend-item">
          <div class="legend-dot legend-dot--primary"></div>
          <span class="legend-name">Conversaciones</span>
        </div>
        <i
          class="pi pi-info-circle card-info"
          pTooltip="Evolución mensual del número de conversaciones con el chatbot"
          tooltipPosition="top"
          appendTo="body"
        ></i>
      </div>
    </div>

    <div class="monthly-chart-container">
      <canvas
        baseChart
        *ngIf="hasMonthlyBarData; else noDataTemplateLine"
        [type]="'line'"
        [data]="monthlyBarData"
        [options]="monthlyBarOptions"
        data-testid="chart-monthly-conversations-canvas"
        data-chart-type="monthly-conversations"
      ></canvas>
    </div>
  </div>

  <!-- No-data templates -->
  <ng-template #noDataTemplateActivity>
    <div class="no-data" data-testid="chart-hours-no-data">
      <i class="pi pi-chart-bar"></i>
      <span>Aún no tienes datos para mostrar</span>
    </div>
  </ng-template>

  <ng-template #noDataTemplateKeywords>
    <div class="no-data" data-testid="chart-keywords-no-data">
      <i class="pi pi-tags"></i>
      <span>Aún no tienes datos para mostrar</span>
    </div>
  </ng-template>

  <ng-template #noDataTemplatePie>
    <div class="no-data" data-testid="chart-channels-no-data">
      <i class="pi pi-chart-pie"></i>
      <span>Aún no tienes datos para mostrar</span>
    </div>
  </ng-template>

  <ng-template #noDataTemplateFeedback>
    <div class="no-data" data-testid="chart-feedback-no-data">
      <i class="pi pi-chart-pie"></i>
      <span>Necesitas más conversaciones valoradas para ver resultados</span>
    </div>
  </ng-template>

  <ng-template #noDataTemplateLine>
    <div class="no-data" data-testid="chart-monthly-conversations-no-data">
      <i class="pi pi-chart-bar"></i>
      <span>Aún no tienes datos para mostrar</span>
    </div>
  </ng-template>
</div>
